const Status = ({ persistentString = '', display = '' }) => ({
  persistentString: String(persistentString),
  display: String(display),
});

const SelfServeOnboardingStatus = ({
  isSelfServeOnboardingInProgress = false,
  status = {},
  productType = '',
  isUpdateRestricted = true,
} = {}) => ({
  isSelfServeOnboardingInProgress: Boolean(isSelfServeOnboardingInProgress),
  status: Status(status),
  productType: String(productType),
  isUpdateRestricted: Boolean(isUpdateRestricted),
});

export default SelfServeOnboardingStatus;

export type SelfServeOnboardingStatusProps = ReturnType<typeof SelfServeOnboardingStatus>;
